<div fxFlex fxLayout="column" fxLayoutAlign="space-between stretch" class="profile-card">
    <div class="tt-margin--bottom">
        <div *ngFor="let item of items" fxLayout="row" fxLayoutAlign="space-between start">
            <forge-label-value>
                <div slot="label">{{item.Display}}</div>
                <span slot="value" class="profile-card--value">{{item.Value}}</span>
            </forge-label-value>
        </div>
    </div>

    <forge-button *ngIf="passwordExpiring" variant="raised" theme="error" type="button"
                  (click)="onChangePasswordClick()" class="tt-margin--bottom">
        Change password
    </forge-button>

    <div *ngIf="showWebLauncherDownload" fxFlex="100" fxLayout="row" fxLayoutAlign="center center"
         class="tt-margin--bottom">
        <forge-button variant="tonal" type="button" (click)="onDownloadWebLauncherClick()"
                      telemetry="Download WebLauncher Clicked">
            Download WebLauncher
        </forge-button>
    </div>

    <div *ngIf="notifications > 0" fxFlex="100" fxLayout="row" fxLayoutAlign="center center" class="tt-margin--bottom">
        <forge-button variant="tonal" type="button" (click)="onViewClick()" telemetry="View Process Status">
            Notifications ({{notifications}})
        </forge-button>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between start" class="profile-card--footer">
        <span fxFlex="auto"></span>
        <div>{{version}}</div>
    </div>
</div>